<template>
    <span>
        <div>
            <!-- Begin:PageContent:Main -->
            <section id="content" :class="{ 'image-bg2': CONF_MOURNING == 'false', 'image-bg2-mourning': CONF_MOURNING == 'true' }">
                <div class="container">
                    <div class="row">
                        <div class="alert alert-info" v-if="CONF_MOURNING == 'false'">
                            {{ alertmessage2[getCurrentLocale] }}
                            <span class="close"></span>
                        </div>

                        <!-- Begin:Content:KeyDestinations -->
                        <sdr-mourning modulo="booking" v-if="CONF_MOURNING == 'true'" style="padding-bottom: 40px;"></sdr-mourning>
                        <!-- End:Content:KeyDestinations -->


                        <!-- Begin:Content-FlightSearchTabs-Booking -->
                        <div id="main" class="col-sm-8 col-md-9">
                            <sdr-shared-flightsearch-tabs modulo="booking"></sdr-shared-flightsearch-tabs>
                        </div>
                        <!-- Begin:Content-FlightSearchTabs-Booking -->


                        <!-- Begin:Content-SideBar-Booking -->
                        <div class="sidebar col-sm-4 col-md-3">
                            <sdr-contact-box></sdr-contact-box>
                        </div>
                        <!-- End:Content-SideBar-Booking -->
                    </div>
                </div>
            </section>
            <!-- End:PageContent:Main -->


            <!-- Begin:Content:KeyDestinations -->
            <!-- <sdr-keydestinations modulo="booking" v-if="CONF_MOURNING == 'false'"></sdr-keydestinations> -->
            <!-- End:Content:KeyDestinations -->

            <!-- Begin:Content:FlightSearchResults -->
            <sdr-shared-flightsearchresults modulo="booking"></sdr-shared-flightsearchresults>
            <!-- End:Content:FlightSearchResults -->

            <!-- Begin:Content:FurtherServices -->
            <!-- <sdr-furtherserives v-if="CONF_MOURNING == 'false'"></sdr-furtherserives> -->
            <!-- End:Content:FurtherServices -->

            <!-- Begin:PromoBox -->
            <!-- <sdr-promobox-sundair-app v-if="CONF_MOURNING == 'false'"></sdr-promobox-sundair-app> -->
            <!-- End:PromoBox -->



        </div>




    </span>
</template>

<script>
    import { CONF_MOURNING }  from '../../config.js';

    import FlightSearchTabs from '../shared/flightsearch/FlightSearchTabs.vue'; // Entire Tabs Construct (shared)
    import FlightSearchResults from '../shared/flightsearch/FlightSearchResults.vue'; // Content

    import ContactBox from '../shared/sidebar/ContactBox.vue'; // Sidebar (right)

    import KeyDestinations from '../booking/pagecontent/KeyDestinations.vue'; // Content
    import FurtherServices from '../booking/pagecontent/FurtherServices.vue'; // Content
    import PromoBoxSundairApp from '../booking/pagecontent/PromoBoxSundairApp.vue';

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-flightsearch-tabs': FlightSearchTabs,
            'sdr-shared-flightsearchresults': FlightSearchResults,

            'sdr-contact-box': ContactBox,
            'sdr-keydestinations': KeyDestinations,
            'sdr-furtherserives': FurtherServices,
            'sdr-promobox-sundair-app': PromoBoxSundairApp,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                alertmessage2: {
                    en: 'Online check-in: Online check-in is not available at the moment. Please check in as usual at the counter.',
                    de: 'Online Check-in: Ein Online Check-in steht im Moment nicht zur Verfügung. Bitte checken Sie wie gewohnt am Schalter ein.',
                },
                alertmessage3: {
                    en: 'Currently, due to technical problems, payment by credit card is not possible. Bookings and payments by direct debit are still possible until 7 days before departure.',
                    de: 'Aktuell ist aufgrund technischer Probleme keine Zahlung per Kreditkarte möglich. Buchungen und Zahlungen per Lastschrift sind weiterhin bis 7 Tage vor Abflug möglich.',
                },
                // >>> ---------------------------------------------------------
                modal_headline: {
                    en: 'Attention: Strike in Bremen',
                    de: 'Achtung: Streik in Bremen',
                },
                modal_content: {
                    en: 'Dear passenger,<br /><br />due to the strike on 17.2.2023 your flight from/ to Bremen to/ from Fuerteventura will now operate from / to Lübeck at the following flight times:<br /><br />Local times<br />17.02.2023 SR3352 Lübeck from 8: 40 - Fuerteventura from 13: 05<br />17.02.2023 SR3353 Fuerteventura from 13: 55 - Lübeck to 19: 50<br /><br />A transfer to/from Lübeck will not be organized by Sundair, please travel on your own to/from Lübeck.',
                    de: 'Sehr geehrter Passagier, <br /><br />aufgrund des Streiks am 17.2.2023 wird Ihr Flug ab/an Bremen nach/von Fuerteventura nunmehr ab/an Lübeck zu folgenden Flugzeiten operieren:<br /><br />Ortszeiten<br />17.02.2023 SR3352 Lübeck ab 8: 40 - Fuerteventura ab 13: 05<br />17.02.2023 SR3353 Fuerteventura ab 13: 55 - Lübeck an 19: 50<br /><br />Ein Transfer nach/von Lübeck wird durch Sundair nicht organisiert, bitte reisen Sie selbstständig an bzw. ab.',
                },
                closemodal: {
                    en: 'Close',
                    de: 'Schliessen',
                },
                // >>> ---------------------------------------------------------
                CONF_MOURNING: CONF_MOURNING,
            };

        }, // eof data()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters(['getCurrentLocale']),

        }, // eof computed{}
        /* <<< ****************************************************************/




        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        * Note:
        *
        */
		mounted: function () {

            let me = this;


            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> mounted');

        }, // eo function mounted()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Methods */
        methods: {

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .alert.alert-info {
        background: #fff;
        color: #2d3e52;
        margin-left: 15px;
        margin-right: 15px;
        font-size: 14px;
        font-weight: 400;
    }
    .alert.alert-warning {
        background: red;
        color: #fff;
        margin-left: 15px;
        margin-right: 15px;
        font-size: 14px;
        font-weight: 400;
    }
    .alert .close,
    .info-box .close {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/booking/Home.vue